import { formatDate } from "@/utils/helper";
import Image from "next/image";
import Link from "next/link";

const BlogCard = ({
  slug,
  src,
  blogCategory,
  title,
  date,
  description,
  alt,
}) => {
  return (
    <Link href={`/blog/${slug}`}>
      <a className="block lg:pb-14 h-full mb-10 lg:mb-0">
        <div className="fs-0 [&_img]:h-auto [&_img]:w-full [&_img]:!relative [&>span>span]:!hidden [&>span]:!block">
          <Image
            src={src}
            width={309}
            height={253}
            alt={alt}
            className="rounded-2xl overflow-hidden !w-full !h-auto"
          />
        </div>
        <p className="text-sm text-primary-yellow !pb-3 !pt-5 lg:pt-7">
          <span>{blogCategory}</span>
        </p>
        <h5 className="font-bold text-2xl text-white !pb-1 text-ellipsis overflow-hidden line-clamp-2">
          <span dangerouslySetInnerHTML={{ __html: title.rendered }}></span>
        </h5>
        <p className="text-sm text-white !pb-4">
          <span>{formatDate(date)}</span>
        </p>
        <div
          className="text-sm text-white tracking-wide text-ellipsis overflow-hidden line-clamp-2"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        ></div>
      </a>
    </Link>
  );
};

export default BlogCard;
